/* eslint-disable max-lines-per-function */
import loadJS from "common/utils/request/loadjs";
import { sendDataLayer } from "jiffy-analytics";
import { loadPackage } from "common/utils/package-loader";
import "./product-video.scss";

const checkIsLoaded = player => {
  const playerLoaded = () =>
    new Promise(resolve => {
      player.on("loaded", () => {
        resolve(true);
      });
    });

  const timeout = () =>
    new Promise(resolve => {
      setTimeout(() => resolve(false), 5000);
    });
  return Promise.race([playerLoaded(), timeout()]);
};

export default () => {
  const videos = Array.from(document.querySelectorAll(".js-product-video:not(.initialized)"));

  videos.forEach($block => {
    const $element = $block.querySelector(".js-product-video-block");
    const $spinner = $block.querySelector(".js-product-video-spinner");
    if (!$element || !$spinner) return;

    const videoUrl = $element.src;
    const urlPath = videoUrl.split("?")[0];
    let played = false;

    $block.classList.add("initialized");

    if (videoUrl.match("vimeo.com")) {
      loadPackage("vimeo").then(VimeoPlayer => {
        const player = new VimeoPlayer($element);

        player.ready().then(() => {
          $spinner.classList.add("hidden");
          $element.classList.remove("product-video__block--hidden");

          player.on("play", () => {
            if (played) return;

            sendDataLayer({
              genericEvent: true,
              event: "play",
              eventCategory: "Videos",
              eventLabel: urlPath
            });
            played = true;
          });
        });

        checkIsLoaded(player).then(success => {
          if (success) return;

          $spinner.classList.add("hidden");
          $element.parentElement.remove();
        });
      });
    } else if (videoUrl.match("youtube.com")) {
      $spinner.classList.add("hidden");
      $element.classList.remove("product-video__block--hidden");

      // triggers callback after youtube js api file loaded
      window.onYouTubeIframeAPIReady = () => {
        if (!window.YT.Player) {
          return;
        }

        const handleStateChange = event => {
          if (played) {
            return;
          }

          if (
            [window.YT.PlayerState.UNSTARTED, window.YT.PlayerState.PLAYING].includes(event.data)
          ) {
            sendDataLayer({
              genericEvent: true,
              event: "play",
              eventCategory: "Videos",
              eventLabel: urlPath
            });
            played = true;
          }
        };

        // eslint-disable-next-line no-new
        const player = new window.YT.Player($element.id, {
          events: {
            onReady: () => {
              player.addEventListener("onStateChange", handleStateChange);
            }
          }
        });
      };

      // in case if youtube js script already loaded
      if (window.YT) {
        window.onYouTubeIframeAPIReady();
      } else {
        loadJS("//www.youtube.com/iframe_api");
      }
    } else {
      $spinner.classList.add("hidden");
      $element.classList.remove("product-video__block--hidden");

      $element.addEventListener("play", () => {
        if (played) return;

        sendDataLayer({
          genericEvent: true,
          event: "play",
          eventCategory: "Videos",
          eventLabel: urlPath
        });
        played = true;
      });
    }
  });
};
